export default "__VITE_ASSET__e1b1481a__"